import { useEffect } from 'react'
import { useFetchUserData } from 'src/Hooks/useFetchUserData'
import { useTypedSelector } from 'src/State/RootReducer'
import { useUser } from 'src/Hooks/useUser'

/**
 * Hook to initialise the user company data
 */
const useInitUserCompanyData = (): void => {
  const userId = useTypedSelector(state => state.auth.userId)
  const { fetchCompany } = useFetchUserData()
  const { setUserCompany, userData } = useUser()

  useEffect(() => {
    const initUserData = async (): Promise<void> => {
      if (userData?.Firmen_ID) {
        fetchCompany(userData?.Firmen_ID).then(company => {
          if (company) {
            setUserCompany(company)
          }
        })
      }
    }
    initUserData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, userData?.Firmen_ID])
}

export default useInitUserCompanyData
